<template>
  <div class="role-line-menu">
    <MenuIcon
      :dropdownItems="visibleMenuItems"
      :isOpen="isMenuOpen"
      @onClick="handleMenuClick"
      :width="280"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import MenuIcon from '@components/MenuIcon/MenuIcon.vue';

const props = defineProps({
  status: {
    type: String,
    default: 'Draft',
    validator: s => ['Draft', 'Active', 'Retired', 'Archived'].includes(s)
  },
  roleName: {
    type: String,
    default: ''
  },
  menuOpen: {
    type: Boolean,
    default: false
  },
  /** Organization roles list and role detail header can show bulk attach to positions. */
  showAttachToPositionsBulk: {
    type: Boolean,
    default: false
  },
  /** Header menus (Role detail page) keep Delete + Attach to Positions in Bulk; row menus do not. */
  isHeaderMenu: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['action']);

const isMenuOpen = ref(props.menuOpen);

watch(() => props.menuOpen, (newVal) => {
  isMenuOpen.value = newVal;
});

const visibleMenuItems = computed(() => [
  props.status === 'Draft' && {
    name: 'Activate', value: 'activate', icon: 'icons/dropdown/activate.svg', destructive: false
  },
  props.status === 'Draft' && {
    name: 'Delete', value: 'delete', icon: 'icons/dropdown/delete.svg', destructive: true, negative: true
  },
  props.status === 'Active' && {
    name: 'Retire', value: 'retire', icon: 'icons/dropdown/activate.svg', destructive: false
  },
  props.status === 'Retired' && {
    name: 'Reactivate', value: 'reactivate', icon: 'icons/dropdown/activate.svg', destructive: false
  },
  // Attach Responsibility always visible
  {
    name: 'Attach Responsibility', value: 'attachResponsibility', icon: 'icons/dropdown/attach.svg', destructive: false
  },
  props.isHeaderMenu && props.showAttachToPositionsBulk && {
    name: 'Attach to Positions in Bulk', value: 'attachToPositionsBulk', icon: 'icons/dropdown/attach.svg', destructive: false
  },
  // Rename always visible
  {
    name: 'Rename', value: 'rename', icon: 'icons/dropdown/rename.svg', destructive: false
  },
  props.status === 'Retired' && {
    name: 'Archive', value: 'archive', icon: 'icons/dropdown/activate.svg', destructive: true, negative: true
  },
  props.status === 'Archived' && {
    name: 'Unarchive', value: 'unarchive', icon: 'icons/dropdown/activate.svg', destructive: false
  }
].filter(Boolean));

function handleMenuClick(item) {
  isMenuOpen.value = false;
  emit('action', item.value);
}

defineExpose({ handleMenuClick, visibleMenuItems });
</script>
<style scoped>
.role-line-menu {
  width: 20%;
  text-align: end;
}
</style>